<template>
    <div :class="[$options.name]">
        <UserFilter />
        <div class="overflow-scroll list-height">
            <ul class="divide-y divide-gray-200">
                <EventEntry
                    v-for="event in computedEventsList"
                    :key="event.id"
                    :component-data="event"
                />
            </ul>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { defineComponent } from 'vue'
import EventEntry from '@/components/EventEntry.vue'
import UserFilter from '@/components/UserFilter.vue'

export default defineComponent({
    name: 'EventsList',
    components: {
        UserFilter,
        EventEntry,
    },
    computed: {
        ...mapState('events', { computedEventsList: (state) => state.data }),
    },
})
</script>

<style>
.list-height {
    height: calc(100% - var(--filter-control-height));
}
</style>
